import type { QueryClient } from '@tanstack/react-query';

import { redirect } from '@tanstack/react-router';

import { getAuthFromQueryClient } from '../auth/hooks';
import { canReviewUnconfirmed, settingsSectionAllowed } from '../auth/roles';

/** beforeLoad guard for one settings section; the parent /settings route already requires a signed-in role. */
export async function requireSettingsSection(queryClient: QueryClient, section: string): Promise<void> {
  const auth = await getAuthFromQueryClient(queryClient);
  if (!settingsSectionAllowed(section, auth?.user.role)) {
    throw redirect({ to: '/unauthorized' });
  }
}

/** beforeLoad guard for /unconfirmed-groups. */
export async function requireUnconfirmedReview(queryClient: QueryClient): Promise<void> {
  const auth = await getAuthFromQueryClient(queryClient);
  if (!auth?.user) {
    throw redirect({ to: '/login', search: { redirectTo: '/unconfirmed-groups' } });
  }
  if (!canReviewUnconfirmed(auth)) {
    throw redirect({ to: '/unauthorized' });
  }
}
